// import React, { Component } from "react";
// import { Col, Row, Accordion, Form, Button } from "react-bootstrap";
// import { toast } from "react-toastify";
// import configData from "../../config.json";
// import "./motorpolicies.css";
// export default class McustomerDetails extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       sId: sessionStorage.getItem("sessionId"),
//       uId: sessionStorage.getItem("uId"),
//       integId: 327,
//       responseId: 1748513330,
//       baseIDV: "",
//       net_premium: "2541",
//       cpatenure: "",
//       minimumIDV: "31500",
//       maximumIDV: "45500",
//       ex_showroom_price: "100000",
//       nominee_name: "IFOR IROF",
//       nominee_relation: "Brother",
//       nominee_age: "21",
//       customizeidvvalue: "",
//       fleetppolicy: "",
//       electrical_prem: "",
//       non_electrical_prem: "",
//       proposer_salutation: "Ms",
//       proposer_fname: " ",
//       proposer_mname: "",
//       proposer_lname: "RAGHAV",
//       proposer_dob: "1988-08-02",
//       pre_insurer_name: "BAJAJ ALLIANZ GENERAL INSURANCE CO.LTD",
//       pre_insurer_no: "87655454556767",
//       pannumber: "",
//       gstinnumber: "",
//       proposer_add1: "PUNE",
//       proposer_add2: "PUNE",
//       proposer_add3: "PUNE",
//       proposer_state: "MAHARASHTRA",
//       villagedist: "",
//       proposer_pincode: "400001",
//       proposer_email: "akshata@tataaig.com",
//       fletpolicy: false,
//       hasvehicleloan: false,
//       clearanceloan: "",
//       proposer_mobile: "",
//       financier_type: "",
//       financier_name: "",
//       vehicle_chassis: "VBJRIR984959407654",
//       vehicle_engine: "DFHKY58949588",
//       vehicle_puc_declaration: "false",
//       vehicle_puc: "",
//       vehicle_puc_expiry: "",
//       bund_od_pol_number: "",
//       bund_od_add: "",
//       bund_od_insurer_name: "",
//       bund_tp_pol_number: "",
//       bund_tp_add: "",
//       bund_tp_insurer_name: "",
//       pre_od_insurer_code: "",
//       pre_od_insurer_name: "",
//       pre_od_policy_no: "",
//       pre_tp_insurer_code: "",
//       pre_tp_insurer_name: "",
//       pre_tp_pol_no: "",
//       currentStep: 1,
//     };
//   }
//   showToast = (msg, type) => {
//     switch (type) {
//       case "success":
//         toast.success(msg);
//         break;
//       case "error":
//         toast.error(msg);
//         break;
//       case "warning":
//         toast.warn(msg); // 'warn' is used instead of 'warning'
//         break;
//       default:
//         toast.success(msg);
//     }
//   };
//   componentDidMount() {
//     this.ResponsejsonfetchHandler();
//     // this.ResponsejsonproposalfetchHandler();
//   }
//   ResponsejsonfetchHandler = (format = "nested") => {
//     const formData = new FormData();
//     formData.append("sId", this.state.sId);
//     formData.append("uId", this.state.uId);
//     formData.append("integId", this.state.integId);
//     formData.append("responseId", this.state.responseId);
//     fetch(configData.api_url + "C_Integrationlibrary/retriveResJson", {
//       method: "POST",
//       mode: "cors",
//       body: formData,
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         if (data.status === "success" && data.data) {
//           try {
//             let extractedData = Array.isArray(data.data)
//               ? data.data[0]
//               : data.data;

//             if (typeof extractedData !== "object" || extractedData === null) {
//               extractedData = {};
//             }

//             // If format is flat, flatten it for mapping
//             if (format === "flat") {
//               const flattened = this.flattenJson(extractedData);
//               this.setState({
//                 data: Object.entries(flattened).map(([key, value], index) => ({
//                   id: index + 1,
//                   jsonKey: key,
//                   value: String(value ?? ""),
//                 })),
//                 jsonData: extractedData,
//                 flattenedJson: flattened,
//               });
//             }

//             // If format is raw nested
//             else if (format === "nested") {
//               this.setState({
//                 jsonData: extractedData,
//               });
//             }

//             // If format is specific keys only
//             else if (format === "summary") {
//               const policyData = extractedData.data || {};
//               const nestedData = policyData.data || {};
//               const premiumData = policyData.premium_break_up || {};
//               const totalsaddons = policyData.pol_dlts || {};
//               const remaingingdata = policyData.data || {};
//               this.setState({
//                 quote_id: policyData.quote_id || "",

//                 proposal_id: policyData.proposal_id || "",
//                 policy_id: policyData.policy_id || "",
//                 quote_no: policyData.quote_no || "",

//                 baseIDV: policyData.baseIDV || "",
//                 plan_type: policyData.plan_type || "",
//                 vehicle_make: policyData.vehicle_make || "",
//                 vehicle_model: policyData.vehicle_model || "",
//                 vehicle_variant: policyData.vehicle_variant || "",
//                 net_premium: nestedData.netPremium || "",
//                 final_premium: premiumData.final_premium || "",
//                 pol_dlts: totalsaddons.pol_dlts || "",
//                 data: remaingingdata.data || "",
//                 pol_start_date: new Date(extractedData.pol_start_date),
//                 pol_end_date: new Date(extractedData.pol_end_date),
//                 cpaStartDate: new Date(extractedData.cpaStartDate),
//                 cpaEndDate: new Date(extractedData.cpaEndDate),
//                 pa_owner_tenure: extractedData.pa_owner_tenure || "",
//                 compulsorypersonalaccident:
//                   extractedData.compulsorypersonalaccident || false,
//                 sacpapolicycrosssell:
//                   extractedData.sacpapolicycrosssell || false,
//                 jsonData: extractedData,
//               });
//             }
//           } catch (error) {
//             console.error("Error processing response data:", error);
//             toast.error("Error processing response data");
//           }
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching response JSON:", error);
//         toast.error("Error fetching response data");
//       });
//   };

//   handlePreviousStep = () => {
//     this.setState((prevState) => ({
//       currentStep: Math.max(prevState.currentStep - 1, 1),
//     }));
//   };
//   handleCheckboxhasvehicleloanChange = (e) => {
//     const { name, checked } = e.target;
//     this.setState({ [name]: checked });
//     if (name === "hasvehicleloan" && !checked) {
//       this.setState({
//         previousPolicyType: "",
//         startDate: null,
//         endDate: null,
//         depreciationOpted: false,
//         returnInvoiceOpted: false,
//         claimMade: false,
//       });
//     }
//   };

//   handleNextStep = () => {
//     this.setState((prevState) => ({ currentStep: prevState.currentStep + 1 }));
//   };
//   handleSelectChange = (event) => {
//     this.setState({ cpatenure: event.target.value });
//   };
//   handleNextpage = (e) => {
//     window.location.href = "/mproposelsummary";
//   };

//   // ALL field events

//   handleproposer_fnameChange = (e) => {
//     this.setState({ proposer_fname: e.target.value });
//   };
//   handleproposer_mnameChange = (e) => {
//     this.setState({ proposer_mname: e.target.value });
//   };
//   handleproposer_lnameChange = (e) => {
//     this.setState({ proposer_lname: e.target.value });
//   };
//   handlePanNumberChange = (e) => {
//     this.setState({ pannumber: e.target.value });
//   };
//   handleGSTINnumberChange = (e) => {
//     e.preventDefault();
//     const fieldValue = e.target.value;
//     this.setState({ gstinnumber: fieldValue });
//   };
//   handleBuildingChange = (e) => {
//     e.preventDefault();
//     const fieldValue = e.target.value;
//     this.setState({ proposer_add1: fieldValue });
//   };
//   handlevillageChange = (e) => {
//     e.preventDefault();
//     const fieldValue = e.target.value;
//     this.setState({ proposer_state: fieldValue });
//   };
//   handlePincodeChange = (e) => {
//     e.preventDefault();
//     const fieldValue = e.target.value;
//     this.setState({ proposer_pincode: fieldValue });
//   };
//   handleemailIDChange = (e) => {
//     e.preventDefault();
//     const fieldValue = e.target.value;
//     this.setState({ proposer_email: fieldValue });
//   };

//   handleproposer_dobChange = (e) => {
//     e.preventDefault();
//     const fieldValue = e.target.value;
//     this.setState({ proposer_dob: fieldValue });
//   };
//   handlenomineeNameChange = (e) => {
//     e.preventDefault();
//     const fieldValue = e.target.value;
//     this.setState({ nominee_name: fieldValue });
//   };
//   handlenominee_ageChange = (e) => {
//     e.preventDefault();
//     const fieldValue = e.target.value;
//     this.setState({ nominee_age: fieldValue });
//   };
//   handleproposer_add2Change = (e) => {
//     e.preventDefault();
//     const fieldValue = e.target.value;
//     this.setState({ proposer_add2: fieldValue });
//   };
//   handlenet_premiumChange = (e) => {
//     this.setState({ net_premium: e.target.value });
//   };
//   handleIDVChange = (e) => {
//     this.setState({ idv: e.target.value });
//   };
//   handleexshowroomChange = (e) => {
//     this.setState({ ex_showroom_price: e.target.value });
//   };
//   handleminimumIDVChange = (e) => {
//     this.setState({ minimumIDV: e.target.value });
//   };
//   handleMAXidvvalueChange = (e) => {
//     this.setState({ maximumIDV: e.target.value });
//   };
//   handleCustomizeidvvalueChange = (e) => {
//     this.setState({ customizeidvvalue: e.target.value });
//   };
//   handlefleetpolicyChange = (checkboxName) => {
//     this.setState((prevState) => ({
//       [checkboxName]: !prevState[checkboxName],
//     }));
//   };
//   handleelectrical_premChange = (checkboxName) => {
//     this.setState((prevState) => ({
//       [checkboxName]: !prevState[checkboxName],
//     }));
//   };
//   handlenon_electrical_premChange = (checkboxName) => {
//     this.setState((prevState) => ({
//       [checkboxName]: !prevState[checkboxName],
//     }));
//   };

//   //nominee event

//   handlenomnieenameChange = (e) => {
//     this.setState({ nominee_name: e.target.value });
//   };
//   handlenomnieeageChange = (e) => {
//     this.setState({ nominee_age: e.target.value });
//   };
//   handleNomineeRelationChange = (e) => {
//     e.preventDefault();

//     const fieldValue = e.target.value;
//     this.setState({ nominee_relation: fieldValue });
//   };

//   handleproposer_salutationChange = (e) => {
//     e.preventDefault();

//     const fieldValue = e.target.value;
//     this.setState({ proposer_salutation: fieldValue });
//   };
//   handleSubmitBackClick = (e) => {
//     window.location.href = "/mvinfo";
//   };
//   handleSubmitQuotesBackClick = (e) => {
//     window.location.href = "/mquote";
//   };
//   render() {
//     const { jsonData } = this.state;
//     return (
//       <div>
//         <Row className="mb-2">
//           <Col className="col-md-3 Inactive">
//             <div className="widget_BG widget_BG_grid fill nav-icon bi bi-journal-check">
//               <p className="nav-label mt-2">Vechile Details</p>
//             </div>
//           </Col>

//           <Col className="col-md-3 Inactive">
//             <div
//               className="widget_BG widget_BG_grid bi bi-file-richtext nav-icon"
//               onClick={this.handleSubmitQuotesBackClick}
//             >
//               <p
//                 className="nav-label mt-2"
//                 onClick={this.handleSubmitQuotesBackClick}
//               >
//                 Quotes
//               </p>
//             </div>
//           </Col>
//           <Col className="col-md-3 Inactive">
//             <div
//               className="widget_BG widget_BG_grid bi bi-info-square nav-icon"
//               onClick={this.handleSubmitBackClick}
//             >
//               <p
//                 className="nav-label mt-2"
//                 onClick={this.handleSubmitBackClick}
//               >
//                 Vehicle Info
//               </p>
//             </div>
//           </Col>
//           <Col className="col-md-3  active-page">
//             <div className="widget_BG widget_BG_grid bi bi-file-person nav-icon">
//               <p className="nav-label mt-2 ">Customer Details</p>
//             </div>
//           </Col>
//         </Row>
//         <Row>
//           <Accordion activeKey={this.state.currentStep.toString()}>
//             <Accordion.Item eventKey="1">
//               <Accordion.Header>
//                 <h4>IDV and Policy Perimum</h4>
//               </Accordion.Header>
//               <Accordion.Body>
//                 {jsonData?.data && (
//                   <Row>
//                     <Col md="4" lg="4">
//                       <Form.Group>
//                         <Form.Label>IDV Value &#8377;:</Form.Label>
//                         <Form.Control
//                           type="text"
//                           name="baseIDV"
//                           id="baseIDV"
//                           disabled
//                           value={jsonData?.data?.data?.baseIDV || ""}
//                           onChange={this.handleIDVChange}
//                         />
//                       </Form.Group>
//                     </Col>

//                     <Col md="4" lg="4">
//                       <Form.Group>
//                         <Form.Label>Policy Premium &#8377;:</Form.Label>
//                         <Form.Control
//                           type="text"
//                           name="net_premium"
//                           id="net_premium"
//                           value={jsonData?.data?.data?.net_premium}
//                           onChange={this.handlenet_premiumChange}
//                         />
//                       </Form.Group>
//                     </Col>
//                   </Row>
//                 )}
//                 <Row>
//                   <Col>
//                     <Button
//                       style={{ float: "right" }}
//                       className="mt-3 rounded-0"
//                       onClick={this.handleNextStep}
//                     >
//                       Next
//                     </Button>
//                   </Col>
//                 </Row>
//               </Accordion.Body>
//             </Accordion.Item>
//             <br />
//             <Accordion.Item eventKey="2">
//               <Accordion.Header>
//                 <h4>Vechile Details</h4>
//               </Accordion.Header>
//               <Accordion.Body>
//                 {jsonData?.data && (
//                   <Row>
//                     <Col md="4" lg="4">
//                       <Form.Group>
//                         <Form.Label>Engine Number</Form.Label>
//                         <Form.Control
//                           type="text"
//                           name="vehicle_engine"
//                           disabled
//                           id="vehicle_engine"
//                           value={this.state.vehicle_engine}
//                           onChange={(e) =>
//                             this.handleInputChange(
//                               "vehicle_engine",
//                               e.target.value
//                             )
//                           }
//                         />
//                       </Form.Group>
//                     </Col>
//                     <Col md="4" lg="4">
//                       <Form.Group>
//                         <Form.Label>Chassis Number</Form.Label>
//                         <Form.Control
//                           type="text"
//                           name="vehicle_chassis"
//                           id="vehicle_chassis"
//                           disabled
//                           value={this.state.vehicle_chassis}
//                           onChange={(e) =>
//                             this.handleInputChange(
//                               "vehicle_chassis",
//                               e.target.value
//                             )
//                           }
//                         />
//                       </Form.Group>
//                     </Col>
//                     <Col md="4" lg="4">
//                       <Form.Group>
//                         <Form.Label>Max IDV Value &#8377;:</Form.Label>
//                         <Form.Control
//                           type="text"
//                           name="maximumIDV"
//                           id="maximumIDV"
//                           value={jsonData?.data?.data?.maximumIDV}
//                           onChange={this.handleMAXidvvalueChange}
//                         />
//                       </Form.Group>
//                     </Col>
//                     {/* <Col md="4" lg="4">
//                       <Form.Group>
//                         <Form.Label>Customize IDV Value &#8377;:</Form.Label>
//                         <Form.Control
//                           type="text"
//                           name="customizeidvvalue"
//                           id="customizeidvvalue"
//                           value={jsonData?.data?.data?.customizeidvvalue}
//                           onChange={this.handleCustomizeidvvalueChange}
//                         />
//                       </Form.Group>
//                     </Col> */}
//                   </Row>
//                 )}
//                 <br />
//                 {/* <Row>
//                   {jsonData?.data && (
//                     <Col md="4" lg="4">
//                       <Form.Group>
//                         <Form.Check
//                           type="checkbox"
//                           name="fleetppolicy"
//                           id="fleetppolicy"
//                           className="chekboxlabel"
//                           label="Is Fleet Policy"
//                           checked={
//                             jsonData?.data?.premium_break_up?.fleetppolicy ===
//                             true
//                           }
//                           onChange={(e) =>
//                             this.handlefleetpolicyChange(
//                               "fleetppolicy",
//                               e.target.value
//                             )
//                           }
//                         />
//                       </Form.Group>
//                     </Col>
//                   )}
//                   <Col md="4" lg="4">
//                     <Form.Group>
//                       <Form.Check
//                         type="checkbox"
//                         className="chekboxlabel"
//                         name="electrical_prem"
//                         id="electrical_prem"
//                         label="Electrical Accessories"
//                         checked={
//                           jsonData?.data?.premium_break_up?.electrical_prem ===
//                           true
//                         }
//                         onChange={(e) =>
//                           this.handleelectrical_premChange(
//                             "electrical_prem",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </Form.Group>
//                   </Col>
//                   <Col md="4" lg="4">
//                     <Form.Group>
//                       <Form.Check
//                         type="checkbox"
//                         className="chekboxlabel"
//                         name="non_electrical_prem"
//                         id="non_electrical_prem"
//                         label="Non-Electrical Accessories"
//                         checked={
//                           jsonData?.data?.premium_break_up
//                             ?.non_electrical_prem === true
//                         }
//                         onChange={(e) =>
//                           this.handlenon_electrical_premChange(
//                             "non_electrical_prem",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </Form.Group>
//                   </Col>
//                 </Row> */}
//                 <Row>
//                   <Col>
//                     <Button
//                       className="mt-3 rounded-0"
//                       onClick={this.handlePreviousStep}
//                       style={{ float: "left" }}
//                     >
//                       Back
//                     </Button>
//                   </Col>

//                   <Col>
//                     <Button
//                       style={{ float: "right" }}
//                       className="mt-3 rounded-0"
//                       onClick={this.handleNextStep}
//                     >
//                       Next
//                     </Button>
//                   </Col>
//                 </Row>
//               </Accordion.Body>
//             </Accordion.Item>
//             <br />
//             <Accordion.Item eventKey="3">
//               <Accordion.Header>
//                 <h4>Insured Declared Values of the Vehicle</h4>
//               </Accordion.Header>
//               <Accordion.Body>
//                 {jsonData?.data && (
//                   <Row>
//                     <Col md="4" lg="4">
//                       <Form.Group>
//                         <Form.Label>
//                           Your Vehicle Ex-showroom price &#8377;:
//                         </Form.Label>
//                         <Form.Control
//                           type="text"
//                           name="ex_showroom_price"
//                           id="ex_showroom_price"
//                           value={jsonData?.data?.data?.ex_showroom_price}
//                           onChange={this.handleexshowroomChange}
//                         />
//                       </Form.Group>
//                     </Col>
//                     <Col md="4" lg="4">
//                       <Form.Group>
//                         <Form.Label>Min IDV Value &#8377;:</Form.Label>
//                         <Form.Control
//                           type="text"
//                           name="minimumIDV"
//                           id="minimumIDV"
//                           value={jsonData?.data?.data?.minimumIDV}
//                           onChange={this.handleminimumIDVChange}
//                         />
//                       </Form.Group>
//                     </Col>
//                     <Col md="4" lg="4">
//                       <Form.Group>
//                         <Form.Label>Max IDV Value &#8377;:</Form.Label>
//                         <Form.Control
//                           type="text"
//                           name="maximumIDV"
//                           id="maximumIDV"
//                           value={jsonData?.data?.data?.maximumIDV}
//                           onChange={this.handleMAXidvvalueChange}
//                         />
//                       </Form.Group>
//                     </Col>
//                     {/* <Col md="4" lg="4">
//                       <Form.Group>
//                         <Form.Label>Customize IDV Value &#8377;:</Form.Label>
//                         <Form.Control
//                           type="text"
//                           name="customizeidvvalue"
//                           id="customizeidvvalue"
//                           value={jsonData?.data?.data?.customizeidvvalue}
//                           onChange={this.handleCustomizeidvvalueChange}
//                         />
//                       </Form.Group>
//                     </Col> */}
//                   </Row>
//                 )}
//                 <br />
//                 {/* <Row>
//                   {jsonData?.data && (
//                     <Col md="4" lg="4">
//                       <Form.Group>
//                         <Form.Check
//                           type="checkbox"
//                           name="fleetppolicy"
//                           id="fleetppolicy"
//                           className="chekboxlabel"
//                           label="Is Fleet Policy"
//                           checked={
//                             jsonData?.data?.premium_break_up?.fleetppolicy ===
//                             true
//                           }
//                           onChange={(e) =>
//                             this.handlefleetpolicyChange(
//                               "fleetppolicy",
//                               e.target.value
//                             )
//                           }
//                         />
//                       </Form.Group>
//                     </Col>
//                   )}
//                   <Col md="4" lg="4">
//                     <Form.Group>
//                       <Form.Check
//                         type="checkbox"
//                         className="chekboxlabel"
//                         name="electrical_prem"
//                         id="electrical_prem"
//                         label="Electrical Accessories"
//                         checked={
//                           jsonData?.data?.premium_break_up?.electrical_prem ===
//                           true
//                         }
//                         onChange={(e) =>
//                           this.handleelectrical_premChange(
//                             "electrical_prem",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </Form.Group>
//                   </Col>
//                   <Col md="4" lg="4">
//                     <Form.Group>
//                       <Form.Check
//                         type="checkbox"
//                         className="chekboxlabel"
//                         name="non_electrical_prem"
//                         id="non_electrical_prem"
//                         label="Non-Electrical Accessories"
//                         checked={
//                           jsonData?.data?.premium_break_up
//                             ?.non_electrical_prem === true
//                         }
//                         onChange={(e) =>
//                           this.handlenon_electrical_premChange(
//                             "non_electrical_prem",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </Form.Group>
//                   </Col>
//                 </Row> */}
//                 <Row>
//                   <Col>
//                     <Button
//                       className="mt-3 rounded-0"
//                       onClick={this.handlePreviousStep}
//                       style={{ float: "left" }}
//                     >
//                       Back
//                     </Button>
//                   </Col>
//                   <Col></Col>
//                   <Col>
//                     <Button
//                       style={{ float: "right" }}
//                       className="mt-3 rounded-0"
//                       onClick={this.handleNextStep}
//                     >
//                       Next
//                     </Button>
//                   </Col>
//                 </Row>
//               </Accordion.Body>
//             </Accordion.Item>

//             <br />

//             <Accordion.Item eventKey="4" className="mb-2">
//               <Accordion.Header>
//                 <h4>Customer Details</h4>
//               </Accordion.Header>
//               <Accordion.Body>
//                 <Row>
//                   <Col md="1" lg="1">
//                     <Form.Group controlId="policyType">
//                       <Form.Label>Title</Form.Label>
//                       <Form.Control
//                         as="select"
//                         value={this.state.proposer_salutation}
//                         onChange={this.handleproposer_salutationChange}
//                       >
//                         <option value="">Select</option>
//                         <option value="mr">Mr</option>
//                         <option value="Ms">Ms</option>
//                         <option value="mrs">Mrs</option>
//                         <option value="miss">Miss</option>
//                         <option value="dr">Dr</option>
//                       </Form.Control>
//                     </Form.Group>
//                   </Col>
//                   <Col md="4" lg="4">
//                     <Form.Group>
//                       <Form.Label>First Name</Form.Label>
//                       <Form.Control
//                         type="text"
//                         name="proposer_fname"
//                         id="proposer_fname"
//                         value={this.state.proposer_fname}
//                         onChange={this.handleproposer_fnameChange}
//                       />
//                     </Form.Group>
//                   </Col>
//                   <Col md="3" lg="3">
//                     <Form.Group>
//                       <Form.Label>Middle Name</Form.Label>
//                       <Form.Control
//                         type="text"
//                         name="proposer_mname"
//                         id="proposer_mname"
//                         value={this.state.proposer_mname}
//                         onChange={this.handleproposer_mnameChange}
//                       />
//                     </Form.Group>
//                   </Col>
//                   <Col md="4" lg="4">
//                     <Form.Group>
//                       <Form.Label>Last Name</Form.Label>
//                       <Form.Control
//                         type="text"
//                         name="proposer_lname"
//                         id="proposer_lname"
//                         value={this.state.proposer_lname}
//                         onChange={this.handleproposer_lnameChange}
//                       />
//                     </Form.Group>
//                   </Col>
//                   <Col md="4" lg="4">
//                     <Form.Group>
//                       <Form.Label>Proposer DOB</Form.Label>
//                       <Form.Control
//                         type="text"
//                         name="proposer_dob"
//                         id="proposer_dob"
//                         value={this.state.proposer_dob}
//                         onChange={this.handleproposer_dobChange}
//                       />
//                     </Form.Group>
//                   </Col>
//                   <Col md="4" lg="4">
//                     <Form.Group>
//                       <Form.Label>PAN Number</Form.Label>
//                       <Form.Control
//                         type="text"
//                         name="pannumber"
//                         id="pannumber"
//                         maxLength={10}
//                         value={this.state.pannumber}
//                         onChange={this.handlePanNumberChange}
//                       />
//                     </Form.Group>
//                   </Col>
//                   <Col md="4" lg="4">
//                     <Form.Group>
//                       <Form.Label>GSTIN Number</Form.Label>
//                       <Form.Control
//                         type="text"
//                         name="gstinnumber"
//                         id="gstinnumber"
//                         maxLength={10}
//                         value={this.state.gstinnumber}
//                         onChange={this.handleGSTINnumberChange}
//                       />
//                     </Form.Group>
//                   </Col>
//                 </Row>
//                 <hr />
//                 <Row>
//                   <h4>Contact Details</h4>
//                   <Col md="4" lg="4">
//                     <Form.Group>
//                       <Form.Label>House/Building/Appartment.No</Form.Label>
//                       <Form.Control
//                         type="text"
//                         name="proposer_add1"
//                         id="proposer_add1"
//                         maxLength={10}
//                         value={this.state.proposer_add1}
//                         onChange={this.handleBuildingChange}
//                       />
//                     </Form.Group>
//                   </Col>
//                   <Col md="4" lg="4">
//                     <Form.Group>
//                       <Form.Label>Land Mark</Form.Label>
//                       <Form.Control
//                         type="text"
//                         name="proposer_add2"
//                         id="proposer_add2"
//                         maxLength={10}
//                         value={this.state.proposer_add2}
//                         onChange={this.handleproposer_add2Change}
//                       />
//                     </Form.Group>
//                   </Col>
//                   <Col md="4" lg="4">
//                     <Form.Group>
//                       <Form.Label>State</Form.Label>
//                       <Form.Control
//                         type="text"
//                         name="proposer_state"
//                         id="proposer_state"
//                         maxLength={10}
//                         value={this.state.proposer_state}
//                         onChange={this.handlevillageChange}
//                       />
//                     </Form.Group>
//                   </Col>
//                   <Col md="4" lg="4">
//                     <Form.Group>
//                       <Form.Label>Pincode</Form.Label>
//                       <Form.Control
//                         type="text"
//                         name="proposer_pincode"
//                         id="proposer_pincode"
//                         maxLength={10}
//                         value={this.state.proposer_pincode}
//                         onChange={this.handlePincodeChange}
//                       />
//                     </Form.Group>
//                   </Col>
//                   <Col md="4" lg="4">
//                     <Form.Group>
//                       <Form.Label>Email-ID</Form.Label>
//                       <Form.Control
//                         type="text"
//                         name="proposer_email"
//                         id="proposer_email"
//                         maxLength={10}
//                         value={this.state.proposer_email}
//                         onChange={this.handleemailIDChange}
//                       />
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Row>
//                   <Col>
//                     <Button
//                       className="mt-3 rounded-0"
//                       onClick={this.handlePreviousStep}
//                       style={{ float: "left" }}
//                     >
//                       Back
//                     </Button>
//                   </Col>
//                   <Col>
//                     <Button
//                       style={{ float: "right" }}
//                       className="mt-3 rounded-0"
//                       onClick={this.handleNextStep}
//                     >
//                       Next
//                     </Button>
//                   </Col>
//                 </Row>
//               </Accordion.Body>
//             </Accordion.Item>
//             <Accordion.Item eventKey="5" className="mb-2">
//               <Accordion.Header>
//                 <h4>Vehicle Loan Details </h4>
//               </Accordion.Header>
//               <Accordion.Body>
//                 <Row>
//                   <Col md="4" lg="4">
//                     <Form>
//                       <Form.Group controlId="previousPolicy">
//                         <Form.Check
//                           type="checkbox"
//                           className="chekboxlabel"
//                           label="Is Vehicle is in loan?"
//                           name="hasvehicleloan"
//                           checked={this.state.hasvehicleloan}
//                           onChange={this.handleCheckboxhasvehicleloanChange}
//                         />
//                       </Form.Group>
//                     </Form>
//                   </Col>
//                 </Row>
//                 {this.state.hasvehicleloan && (
//                   <Row>
//                     <Col md="4" lg="4">
//                       <Form.Group>
//                         <Form.Label>Bank Details</Form.Label>
//                         <Form.Control
//                           type="text"
//                           name="nominee_name"
//                           id="nominee_name"
//                           value={this.state.nominee_name}
//                           onChange={this.handlenomineeNameChange}
//                         />
//                       </Form.Group>
//                     </Col>
//                     <Col md="4" lg="4">
//                       <Form.Group>
//                         <Form.Label>Loan details</Form.Label>
//                         <Form.Control
//                           type="text"
//                           name="nominee_age"
//                           id="nominee_age"
//                           value={this.state.nominee_age}
//                           onChange={this.handlenominee_ageChange}
//                         />
//                       </Form.Group>
//                     </Col>
//                     <Col lg="4" md="4">
//                       <Form.Group controlId="policyType">
//                         <Form.Label>Clearance date</Form.Label>
//                         <Form.Control
//                           type="text"
//                           name="clearanceloan"
//                           id="clearanceloan"
//                           value={this.state.clearanceloan}
//                           onChange={this.handlenChange}
//                         />
//                       </Form.Group>
//                     </Col>
//                   </Row>
//                 )}
//                 <Row>
//                   <Col>
//                     <Button
//                       className="mt-3 rounded-0"
//                       onClick={this.handlePreviousStep}
//                       style={{ float: "left" }}
//                     >
//                       Back
//                     </Button>
//                   </Col>
//                   <Col>
//                     <Button
//                       style={{ float: "right" }}
//                       className="mt-3 rounded-0"
//                       onClick={this.handleNextStep}
//                     >
//                       Next
//                     </Button>
//                   </Col>
//                 </Row>
//               </Accordion.Body>
//             </Accordion.Item>

//             <Accordion.Item eventKey="6" className="mb-2">
//               <Accordion.Header>
//                 <h4>Previous Insurance Details </h4>
//               </Accordion.Header>
//               <Accordion.Body>
//                 <Row>
//                   <Col md="4" lg="4">
//                     <Form.Group>
//                       <Form.Label>Previous Insurer Name</Form.Label>
//                       <Form.Control
//                         type="text"
//                         name="pre_insurer_name"
//                         id="pre_insurer_name"
//                         value={this.state.pre_insurer_name}
//                         onChange={this.handleInsurernameChange}
//                       />
//                     </Form.Group>
//                   </Col>
//                   <Col md="4" lg="4">
//                     <Form.Group>
//                       <Form.Label>Previous Policy Number</Form.Label>
//                       <Form.Control
//                         type="text"
//                         name="pre_insurer_no"
//                         id="pre_insurer_no"
//                         value={this.state.pre_insurer_no}
//                         onChange={this.handleInputChange}
//                       />
//                     </Form.Group>
//                   </Col>
//                 </Row>
//                 <br />
//                 <Row>
//                   <Col>
//                     <Button
//                       className="mt-3 rounded-0"
//                       onClick={this.handlePreviousStep}
//                       style={{ float: "left" }}
//                     >
//                       Back
//                     </Button>
//                   </Col>
//                   <Col>
//                     <Button
//                       style={{ float: "right" }}
//                       className="mt-3 rounded-0"
//                       onClick={this.handleNextpage}
//                     >
//                       Next
//                     </Button>
//                   </Col>
//                 </Row>
//               </Accordion.Body>
//             </Accordion.Item>

//             {/* <Accordion.Item eventKey="7" className="mb-2">
//               <Accordion.Header>
//                 <h4>Inspection Details</h4>
//               </Accordion.Header>
//               <Accordion.Body>
//                 <Row>
//                   <Col md="4" lg="4">
//                     <Form.Group>
//                       <Form.Label>Inspection Reference Number</Form.Label>
//                       <Form.Control
//                         type="text"
//                         name="inspectionreferencenumber"
//                         id="inspectionreferencenumber"
//                         value={this.state.inspectionreferencenumber}
//                         onChange={this.handleInputChange}
//                       />
//                     </Form.Group>
//                   </Col>
//                   <Col className="mt-4">
//                     <Button
//                       variant="secondary"
//                       className="btn-button  rounded-0 m-1"
//                     >
//                       Add Inspection
//                     </Button>

//                     <Button
//                       variant="secondary "
//                       className="btn-button  rounded-0 m-1"
//                     >
//                       Vehicle Specfic Inspection Override
//                     </Button>

//                     <Button
//                       variant="secondary"
//                       className="btn-buttonm-2 rounded-0 m-1"
//                     >
//                       Inspection Override
//                     </Button>
//                   </Col>
//                 </Row>

//                 <Row>
//                   <Col>
//                     <Col md="4" lg="4">
//                       <Form.Group>
//                         <Form.Check
//                           type="checkbox"
//                           className="chekboxlabel"
//                           name="agentdeclaration"
//                           id="agentdeclaration"
//                           label="Agent Declaration"
//                           value={this.state.agentdeclaration}
//                           // onChange={
//                           //   this.handleInputChange("engineNumber", e.target.value)
//                           // }
//                         />
//                       </Form.Group>
//                     </Col>
//                   </Col>
//                 </Row>
//                 <Row>
//                   <Col>
//                     <Button
//                       className="rounded-0"
//                       onClick={this.handlePreviousStep}
//                       style={{ float: "left" }}
//                     >
//                       Back
//                     </Button>
//                   </Col>

//                   <Col>
//                     <Button variant="primary" className="btn-button  rounded-0">
//                       Proceed
//                     </Button>
//                   </Col>
//                   <Col>
//                     <Button
//                       style={{ float: "right" }}
//                       className="rounded-0"
//                       variant="primary"
//                       onClick={this.MototquoterequestsubmitHandler}
//                     >
//                       Review Proposal
//                     </Button>
//                   </Col>
//                 </Row>
//               </Accordion.Body>
//             </Accordion.Item> */}
//           </Accordion>
//         </Row>
//       </div>
//     );
//   }
// }
import React, { Component } from "react";
import { Col, Row, Accordion, Form, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import configData from "../../config.json";
import "./motorpolicies.css";

export default class McustomerDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      integId: 327,
      responseId: 1748513330,

      // Quote and Policy Data
      quote_id: "",
      proposal_id: "",
      policy_id: "",
      quote_no: "",
      pol_start_date: "",
      pol_end_date: "",

      // Vehicle Data
      vehicle_make: "",
      vehicle_model: "",
      vehicle_variant: "",
      vehicle_chassis: "",
      vehicle_engine: "",
      dor: "",
      man_year: "",

      // Premium and IDV Data
      baseIDV: "",
      minimumIDV: "",
      maximumIDV: "",
      ex_showroom_price: "",
      net_premium: "",
      final_premium: "",

      // Customer Details
      proposer_salutation: "Ms",
      proposer_fname: "",
      proposer_mname: "",
      proposer_lname: "",
      proposer_dob: "",
      proposer_add1: "",
      proposer_add2: "",
      proposer_add3: "",
      proposer_state: "",
      proposer_pincode: "",
      proposer_email: "",
      proposer_mobile: "",
      pannumber: "",
      gstinnumber: "",

      // Nominee Details
      nominee_name: "",
      nominee_relation: "",
      nominee_age: "",

      // Previous Insurance
      pre_insurer_name: "",
      pre_insurer_no: "",

      // Vehicle Loan
      hasvehicleloan: false,
      financier_type: "",
      financier_name: "",
      clearanceloan: "",

      // UI State
      currentStep: 1,
      jsonData: null,
      loading: false
    };
  }

  componentDidMount() {
    this.fetchQuoteData();
  }

  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  fetchQuoteData = async () => {
    this.setState({ loading: true });

    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", this.state.integId);
    formData.append("responseId", this.state.responseId);

    try {
      const response = await fetch(configData.api_url + "C_Integrationlibrary/retriveResJson", {
        method: "POST",
        mode: "cors",
        body: formData,
      });

      const data = await response.json();

      if (data.status === "success" && data.data) {
        this.mapResponseDataToState(data.data);
      } else {
        this.showToast("Failed to fetch quote data", "error");
      }
    } catch (error) {
      console.error("Error fetching quote data:", error);
      this.showToast("Error fetching quote data", "error");
    } finally {
      this.setState({ loading: false });
    }
  };

  mapResponseDataToState = (responseData) => {
    try {
      const policyData = responseData.data || responseData;
      const vehicleData = policyData.data || {};
      const premiumData = policyData.premium_break_up || {};

      this.setState({
        jsonData: responseData,

        // Quote and Policy Information
        quote_id: policyData.quote_id || "",
        proposal_id: policyData.proposal_id || "",
        policy_id: policyData.policy_id || "",
        quote_no: policyData.quote_no || "",
        pol_start_date: policyData.pol_start_date || "",
        pol_end_date: policyData.pol_end_date || "",

        // Vehicle Information
        vehicle_make: policyData.vehicle_make || "",
        vehicle_model: policyData.vehicle_model || "",
        vehicle_variant: policyData.vehicle_variant || "",
        dor: policyData.dor || "",
        man_year: policyData.man_year || "",

        // Premium and IDV Data
        baseIDV: vehicleData.baseIDV || 0,
        minimumIDV: vehicleData.minimumIDV || 0,
        maximumIDV: vehicleData.maximumIDV || 0,
        ex_showroom_price: vehicleData.ex_showroom_price || 0,
        net_premium: vehicleData.netPremium || premiumData.net_premium || 0,
        final_premium: premiumData.final_premium || 0,

        // Previous Insurance (if available in initial data)
        pre_insurer_name: "BAJAJ ALLIANZ GENERAL INSURANCE CO.LTD", // Default as shown in original
        pre_insurer_no: "87655454556767", // Default as shown in original

        // Set default customer data (can be updated by user)
        proposer_fname: " ",
        proposer_lname: "RAGHAV",
        proposer_dob: "1988-08-02",
        proposer_add1: "PUNE",
        proposer_add2: "PUNE",
        proposer_add3: "PUNE",
        proposer_state: "MAHARASHTRA",
        proposer_pincode: String(policyData.proposer_pincode || "400001"),
        proposer_email: policyData.q_producer_email || "akshata@tataaig.com",

        // Nominee defaults
        nominee_name: "IFOR IROF",
        nominee_relation: "Brother",
        nominee_age: "21",

        // Vehicle details for customer form
        vehicle_chassis: "VBJRIR984959407654",
        vehicle_engine: "DFHKY58949588"
      });

      this.showToast("Quote data loaded successfully", "success");
    } catch (error) {
      console.error("Error mapping response data:", error);
      this.showToast("Error processing quote data", "error");
    }
  };

  // Navigation handlers
  handlePreviousStep = () => {
    this.setState((prevState) => ({
      currentStep: Math.max(prevState.currentStep - 1, 1),
    }));
  };

  handleNextStep = () => {
    this.setState((prevState) => ({ currentStep: prevState.currentStep + 1 }));
  };

  handleNextpage = () => {
    window.location.href = "/mproposelsummary";
  };

  handleSubmitBackClick = () => {
    window.location.href = "/mvinfo";
  };

  handleSubmitQuotesBackClick = () => {
    window.location.href = "/mquote";
  };

  // Form field handlers
  handleInputChange = (fieldName, value) => {
    this.setState({ [fieldName]: value });
  };

  handleCheckboxChange = (fieldName) => {
    this.setState((prevState) => ({
      [fieldName]: !prevState[fieldName],
    }));
  };

  // Format currency for display
  formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0
    }).format(amount || 0);
  };

  render() {
    const { loading } = this.state;

    if (loading) {
      return (
        <div className="text-center p-4">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <p>Loading quote data...</p>
        </div>
      );
    }

    return (
      <div>
        {/* Navigation Header */}
        <Row className="mb-2">
          <Col className="col-md-3 Inactive">
            <div className="widget_BG widget_BG_grid fill nav-icon bi bi-journal-check">
              <p className="nav-label mt-2">Vehicle Details</p>
            </div>
          </Col>
          <Col className="col-md-3 Inactive">
            <div
              className="widget_BG widget_BG_grid bi bi-file-richtext nav-icon"
              onClick={this.handleSubmitQuotesBackClick}
            >
              <p className="nav-label mt-2">Quotes</p>
            </div>
          </Col>
          <Col className="col-md-3 Inactive">
            <div
              className="widget_BG widget_BG_grid bi bi-info-square nav-icon"
              onClick={this.handleSubmitBackClick}
            >
              <p className="nav-label mt-2">Vehicle Info</p>
            </div>
          </Col>
          <Col className="col-md-3 active-page">
            <div className="widget_BG widget_BG_grid bi bi-file-person nav-icon">
              <p className="nav-label mt-2">Customer Details</p>
            </div>
          </Col>
        </Row>

        {/* Main Content */}
        <Row>
          <Accordion activeKey={this.state.currentStep.toString()}>

            {/* Step 1: IDV and Policy Premium */}
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <h4>IDV and Policy Premium</h4>
              </Accordion.Header>
              <Accordion.Body>
                <Row>
                  <Col md="4">
                    <Form.Group>
                      <Form.Label>Quote Number:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.quote_no}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md="4">
                    <Form.Group>
                      <Form.Label>IDV Value {this.formatCurrency(0)}:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.formatCurrency(this.state.baseIDV)}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md="4">
                    <Form.Group>
                      <Form.Label>Policy Premium {this.formatCurrency(0)}:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.formatCurrency(this.state.net_premium)}
                        onChange={(e) => this.handleInputChange("net_premium", e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md="6">
                    <Form.Group>
                      <Form.Label>Final Premium {this.formatCurrency(0)}:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.formatCurrency(this.state.final_premium)}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group>
                      <Form.Label>Plan Type:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.jsonData?.data?.plan_type || ""}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button
                      className="mt-3 rounded-0"
                      style={{ float: "right" }}
                      onClick={this.handleNextStep}
                    >
                      Next
                    </Button>
                  </Col>
                </Row>
              </Accordion.Body>
            </Accordion.Item>

            {/* Step 2: Vehicle Details */}
            <Accordion.Item eventKey="2">
              <Accordion.Header>
                <h4>Vehicle Details</h4>
              </Accordion.Header>
              <Accordion.Body>
                <Row>
                  <Col md="4">
                    <Form.Group>
                      <Form.Label>Make:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.vehicle_make}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md="4">
                    <Form.Group>
                      <Form.Label>Model:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.vehicle_model}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md="4">
                    <Form.Group>
                      <Form.Label>Variant:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.vehicle_variant}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md="4">
                    <Form.Group>
                      <Form.Label>Engine Number:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.vehicle_engine}
                        onChange={(e) => this.handleInputChange("vehicle_engine", e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="4">
                    <Form.Group>
                      <Form.Label>Chassis Number:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.vehicle_chassis}
                        onChange={(e) => this.handleInputChange("vehicle_chassis", e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="4">
                    <Form.Group>
                      <Form.Label>Manufacturing Year:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.man_year}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button
                      className="mt-3 rounded-0"
                      onClick={this.handlePreviousStep}
                      style={{ float: "left" }}
                    >
                      Back
                    </Button>
                    <Button
                      className="mt-3 rounded-0"
                      style={{ float: "right" }}
                      onClick={this.handleNextStep}
                    >
                      Next
                    </Button>
                  </Col>
                </Row>
              </Accordion.Body>
            </Accordion.Item>

            {/* Step 3: IDV Values */}
            <Accordion.Item eventKey="3">
              <Accordion.Header>
                <h4>Insured Declared Values of the Vehicle</h4>
              </Accordion.Header>
              <Accordion.Body>
                <Row>
                  <Col md="4">
                    <Form.Group>
                      <Form.Label>Ex-showroom Price {this.formatCurrency(0)}:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.formatCurrency(this.state.ex_showroom_price)}
                        onChange={(e) => this.handleInputChange("ex_showroom_price", e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="4">
                    <Form.Group>
                      <Form.Label>Min IDV Value {this.formatCurrency(0)}:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.formatCurrency(this.state.minimumIDV)}
                        onChange={(e) => this.handleInputChange("minimumIDV", e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="4">
                    <Form.Group>
                      <Form.Label>Max IDV Value {this.formatCurrency(0)}:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.formatCurrency(this.state.maximumIDV)}
                        onChange={(e) => this.handleInputChange("maximumIDV", e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button
                      className="mt-3 rounded-0"
                      onClick={this.handlePreviousStep}
                      style={{ float: "left" }}
                    >
                      Back
                    </Button>
                    <Button
                      className="mt-3 rounded-0"
                      style={{ float: "right" }}
                      onClick={this.handleNextStep}
                    >
                      Next
                    </Button>
                  </Col>
                </Row>
              </Accordion.Body>
            </Accordion.Item>

            {/* Step 4: Customer Details */}
            <Accordion.Item eventKey="4">
              <Accordion.Header>
                <h4>Customer Details</h4>
              </Accordion.Header>
              <Accordion.Body>
                <Row>
                  <Col md="2">
                    <Form.Group>
                      <Form.Label>Title:</Form.Label>
                      <Form.Control
                        as="select"
                        value={this.state.proposer_salutation}
                        onChange={(e) => this.handleInputChange("proposer_salutation", e.target.value)}
                      >
                        <option value="Mr">Mr</option>
                        <option value="Ms">Ms</option>
                        <option value="Mrs">Mrs</option>
                        <option value="Miss">Miss</option>
                        <option value="Dr">Dr</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col md="3">
                    <Form.Group>
                      <Form.Label>First Name:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.proposer_fname}
                        onChange={(e) => this.handleInputChange("proposer_fname", e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="3">
                    <Form.Group>
                      <Form.Label>Middle Name:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.proposer_mname}
                        onChange={(e) => this.handleInputChange("proposer_mname", e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="4">
                    <Form.Group>
                      <Form.Label>Last Name:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.proposer_lname}
                        onChange={(e) => this.handleInputChange("proposer_lname", e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md="4">
                    <Form.Group>
                      <Form.Label>Date of Birth:</Form.Label>
                      <Form.Control
                        type="date"
                        value={this.state.proposer_dob}
                        onChange={(e) => this.handleInputChange("proposer_dob", e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="4">
                    <Form.Group>
                      <Form.Label>PAN Number:</Form.Label>
                      <Form.Control
                        type="text"
                        maxLength={10}
                        value={this.state.pannumber}
                        onChange={(e) => this.handleInputChange("pannumber", e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="4">
                    <Form.Group>
                      <Form.Label>GSTIN Number:</Form.Label>
                      <Form.Control
                        type="text"
                        maxLength={15}
                        value={this.state.gstinnumber}
                        onChange={(e) => this.handleInputChange("gstinnumber", e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <hr />
                <h5>Contact Details</h5>
                <Row>
                  <Col md="4">
                    <Form.Group>
                      <Form.Label>House/Building/Apartment No:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.proposer_add1}
                        onChange={(e) => this.handleInputChange("proposer_add1", e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="4">
                    <Form.Group>
                      <Form.Label>Landmark:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.proposer_add2}
                        onChange={(e) => this.handleInputChange("proposer_add2", e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="4">
                    <Form.Group>
                      <Form.Label>State:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.proposer_state}
                        onChange={(e) => this.handleInputChange("proposer_state", e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md="4">
                    <Form.Group>
                      <Form.Label>Pincode:</Form.Label>
                      <Form.Control
                        type="text"
                        maxLength={6}
                        value={this.state.proposer_pincode}
                        onChange={(e) => this.handleInputChange("proposer_pincode", e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="4">
                    <Form.Group>
                      <Form.Label>Email ID:</Form.Label>
                      <Form.Control
                        type="email"
                        value={this.state.proposer_email}
                        onChange={(e) => this.handleInputChange("proposer_email", e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="4">
                    <Form.Group>
                      <Form.Label>Mobile Number:</Form.Label>
                      <Form.Control
                        type="text"
                        maxLength={10}
                        value={this.state.proposer_mobile}
                        onChange={(e) => this.handleInputChange("proposer_mobile", e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Button
                      className="mt-3 rounded-0"
                      onClick={this.handlePreviousStep}
                      style={{ float: "left" }}
                    >
                      Back
                    </Button>
                    <Button
                      className="mt-3 rounded-0"
                      style={{ float: "right" }}
                      onClick={this.handleNextStep}
                    >
                      Next
                    </Button>
                  </Col>
                </Row>
              </Accordion.Body>
            </Accordion.Item>

            {/* Step 5: Vehicle Loan Details */}
            <Accordion.Item eventKey="5">
              <Accordion.Header>
                <h4>Vehicle Loan Details</h4>
              </Accordion.Header>
              <Accordion.Body>
                <Row>
                  <Col md="12">
                    <Form.Group>
                      <Form.Check
                        type="checkbox"
                        label="Is Vehicle under loan?"
                        checked={this.state.hasvehicleloan}
                        onChange={() => this.handleCheckboxChange("hasvehicleloan")}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {this.state.hasvehicleloan && (
                  <Row>
                    <Col md="4">
                      <Form.Group>
                        <Form.Label>Financier Type:</Form.Label>
                        <Form.Control
                          as="select"
                          value={this.state.financier_type}
                          onChange={(e) => this.handleInputChange("financier_type", e.target.value)}
                        >
                          <option value="">Select Financier Type</option>
                          <option value="bank">Bank</option>
                          <option value="nbfc">NBFC</option>
                          <option value="other">Other</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="4">
                      <Form.Group>
                        <Form.Label>Financier Name:</Form.Label>
                        <Form.Control
                          type="text"
                          value={this.state.financier_name}
                          onChange={(e) => this.handleInputChange("financier_name", e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md="4">
                      <Form.Group>
                        <Form.Label>Loan Clearance Date:</Form.Label>
                        <Form.Control
                          type="date"
                          value={this.state.clearanceloan}
                          onChange={(e) => this.handleInputChange("clearanceloan", e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                )}

                <Row>
                  <Col>
                    <Button
                      className="mt-3 rounded-0"
                      onClick={this.handlePreviousStep}
                      style={{ float: "left" }}
                    >
                      Back
                    </Button>
                    <Button
                      className="mt-3 rounded-0"
                      style={{ float: "right" }}
                      onClick={this.handleNextStep}
                    >
                      Next
                    </Button>
                  </Col>
                </Row>
              </Accordion.Body>
            </Accordion.Item>

            {/* Step 6: Previous Insurance Details */}
            <Accordion.Item eventKey="6">
              <Accordion.Header>
                <h4>Previous Insurance Details</h4>
              </Accordion.Header>
              <Accordion.Body>
                <Row>
                  <Col md="6">
                    <Form.Group>
                      <Form.Label>Previous Insurer Name:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.pre_insurer_name}
                        onChange={(e) => this.handleInputChange("pre_insurer_name", e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group>
                      <Form.Label>Previous Policy Number:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.pre_insurer_no}
                        onChange={(e) => this.handleInputChange("pre_insurer_no", e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Button
                      className="mt-3 rounded-0"
                      onClick={this.handlePreviousStep}
                      style={{ float: "left" }}
                    >
                      Back
                    </Button>
                    <Button
                      className="mt-3 rounded-0"
                      style={{ float: "right" }}
                      onClick={this.handleFormSubmit}
                    >
                      Review Proposal
                    </Button>
                  </Col>
                </Row>
              </Accordion.Body>
            </Accordion.Item>

          </Accordion>
        </Row>
      </div>
    );
  }
}